import React from "react";
import HeaderFour from "../../components/Header/HeaderFour";
import RegisterMain from "./RegisterMain";
import Footer from "../../components/Footer";

const Register = () => {
  return (
    <>
      <HeaderFour />

      <RegisterMain />

      <Footer />
    </>
  );
};

export default Register;
